import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

interface TwitterPixelTrackerProps {}

const pixelId = 'tw-pxtdj-pxtdl'
const pixelSrc = 'https://static.ads-twitter.com/uwt.js'

const TwitterPixel: React.FC<TwitterPixelTrackerProps> = () => {
  const location = useLocation()
  const pixelInitialized = useRef(false)
  useEffect(() => {
    if(pixelInitialized.current && !window.twqInitialized) {
      (function (e: Window, t: Document, n: string, s: any, u: any, a: any) {
        if (!e.twq) {
          s = e.twq = function (...args: any[]) {
            s.exe ? s.exe(...Array.from(args)) : s.queue.push(...Array.from(args))
          }
          s.version = '1.1'
          s.queue = []
          u = t.createElement(n)
          u.async = true
          u.src = pixelSrc
          a = t.getElementsByTagName(n)[0]
          a.parentNode?.insertBefore(u, a)
        }
      })(window, document, 'script', undefined, undefined, undefined)
      pixelInitialized.current = true
      window.twqInitialized = true
    }
    if(window?.twq) {
      window?.twq('config', pixelId)
    }
  }, [ location ])
  return (
    <Helmet>
      {/* Twitter Pixel Base Code */}
      <script>
        {`
          !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
          },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='${pixelSrc}',
          a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
          twq('config','${pixelId}');
        `}
      </script>
    </Helmet>
  )
}

export default TwitterPixel